import React from "react";
import { Box } from "@mui/material";
import NoDataPNG from "../assets/img/nonewnotification.jpg"
const RecordNotFoundNoNewNotification = () => {
  return (
    <Box sx={{ display: "flex", justifyContent: "center", my: 0 }}>
      <div>
        <img src={NoDataPNG} alt="no data found" />
        <br />
      </div>
    </Box>
  );
};
export default RecordNotFoundNoNewNotification;